import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import BranchTable from "../components/BranchTable";
import { getPageName } from "../../../locales/translationUtils";
import { useTranslation } from 'react-i18next';
import NavBar, { NavBarItem } from "../../../components/NavBar";
import { GridColDef } from "@mui/x-data-grid";
import AlertOverlay from "../../../components/Alert";
import { useBranch } from "../../../apis/branch/BranchProvider";
import Paginacao from "../../../types/paginacao";
import Branch from "../../../types/branch";
import { FaEdit } from "react-icons/fa";

const BranchView: React.FC = () => {
    const { branches, apiResponse, fetchBranches } = useBranch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [alert, setAlert] = useState<{ message: string; variant: "success" | "danger" | "warning" | "info" } | null>(null);

    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 20,
        page: 0,
    });

    const [paginacao, setPaginacao] = React.useState({
        pageNum: 0,
        quantityPerPage: 20
    } as Paginacao);
    
    useEffect(() => {
        const newPaginacao = {
            ...paginacao, 
            pageNum: paginationModel.page,
            quantityPerPage: paginationModel.pageSize
        };
        setPaginacao(newPaginacao);
        fetchBranches(newPaginacao);
    }, [paginationModel]);

    useEffect(() => {
        if (location.state?.message) {
            setAlert({ message: location.state.message, variant: location.state.variant });
    
            navigate(location.pathname, { replace: true });
    
            const timeout = setTimeout(() => setAlert(null), 5000);
            return () => clearTimeout(timeout);
        }
    }, [location, navigate]);
     
    const navItems: NavBarItem[] = [
        { label: t('branch.labels.home'), route: "/", iconName: "house-door" },
        { label: t('branch.labels.newBranch'), route: "/Branch/create", iconName: "plus-circle" },
    ];

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: t('branch.fields.id'),
            width: 80,
            renderCell: (params) => (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "black",
                    cursor: "pointer"
                }}
                    onClick={() => navigate(`/branch/${params.row.id}`)}>
                    <FaEdit className="text-primary" style={{ marginRight: "6px", marginLeft: "2px" }}/>
                    {params.row.id}
                </span>
            ),
        },
        { field: "cnpj", headerName: t('branch.fields.cnpj'), width: 200 },
        { field: "name", headerName: t('branch.fields.name'), width: 350 },
        { 
            field: "client", 
            headerName: t('branch.fields.client'), 
            width: 350,
            valueGetter: (client: any) => {
                return client?.name
            } 
        },
    ];

    return (
        <Container fluid style={{ height: 'calc(100vh - 200px)', overflow: 'auto' }}>
        <NavBar items={navItems} />
            <div className="mb-3"></div>
            <h2>{getPageName("branch")}</h2>
            <div className="mb-3"></div>
            <div>
            {alert && (
                <AlertOverlay
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert(null)}
                />
            )}
        </div>
            <BranchTable
                rows={branches || [] as Branch[]}
                columns={columns}
                getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row")}
                apiResponse={apiResponse} 
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
            />
        </Container>
    );
};

export default BranchView;